import React, { useEffect, useState } from "react";

const Expertise = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("show", entry.isIntersecting);
        });
      },
      { threshold: 0.2 }
    );

    document
      .querySelectorAll(
        ".expertise-card, .expertise-heading, .expertise-description"
      )
      .forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const services = [
    {
      title: "Website Design & Development",
      image: "assets/img/icon/website.avif",
      description:
        "At Warrgyizmorsch, they build websites that truly match your business vision. We design and build digital platforms that represent your brand, goals, and values in life. Our team works on the layout, colours, content, and functionality of the websites to make them work for you. We build deliberately flexible, SEO-friendly WordPress-based sites; Joomla-based sites for structured content and e-commerce; and Drupal-based sites that demand a secure, highly performant system. For absolutely unique requirements, we do customized PHP website development right from scratch. Speed matters. We optimize for speed by minimizing code, compressing images, and caching, all of which help your site load fast and rank well.",
    },
    {
      title: "E-commerce Solutions",
      image: "assets/img/icon/e-commerce.avif",
      description:
        "Our e-commerce services smoothen the way for your online business operations and foster steady growth. We consider strong back-end support the basis of stable sales, so our team tends to your e-commerce management needs while you market to increase the revenues. We support businesses that sell shoes, furniture, electronics, and more. Electronics sellers have specific problems regarding customer satisfaction, which we address with all our knowledge and skills. In addition, our services enable outsourcing for increased operational efficiency, expert consultation, flexible/scalable solutions, excellent customer support, and cost advantage. We help to streamline the organization for your benefit and ensure that your customers always have a pleasant experience.",
    },
    {
      title: "Mobile App Development",
      image: "assets/img/icon/mobile app.jpg",
      description:
        "Our mobile applications incorporate the right technology and features that fit your business needs. Our team of experts develops applications on iOS, Android, React Native, Hybrid, and Progressive Web Apps (PWAs), including Ionic to include flexibility and scalability in your project. We also build APIs, backend systems, and custom prototype applications to support your app with strength and performance smoothly. Our core value is in both design and functionality; making sure the app looks great, runs fast, stays secure, and is easy to use. With our mobile app solutions, your business will stay relevant in the future and connected to your customers.",
    },
    {
      title: "Digital Marketing",
      image: "assets/img/icon/service_3d_3.png",
      description:
        "We accomplish independent digital marketing for your online business growth: A team of very experienced individuals zeroes in on actual outcomes, into a smart data-driven approach. Helping UK businesses in gaining online presence, generating good-quality leads, and actual success are our clients. Services include content marketing, email marketing, social media marketing, PPC management, SEO. Warrgyizmorsch allows a good interplay of creativity in research coupled with knowledge of the UK to create strategies that reach out to your audience. We align ourselves with you, listen to your needs, and tailor-make solutions in a collaborative manner as your business grows. Regardless of your status as either a start-up or a strong established brand, we are the partner for your growth, visibility, and strong ROI. Your success is our always-goal.",
    },
    {
      title: "Accounting & Bookkeeping",
      image: "assets/img/icon/accountandbook.jpg",
      description:
        "Our accounting and bookkeeping services extend throughout the UK for all sizes of business. Payroll, tax returns, accounts payable, receivable, management reports, and so forth-all financial affairs are carried out by us, letting you concentrate on building your business. Migration to a different accounting software, along with support for travel and expense claims are also offered by us. All these services are customised around your business size, structure, and concept. Whether you require basic bookkeeping or complete financial management, we are prepared to assist. Using secure cloud-based tools, real-time access & complete confidentiality are offered. So, you remain in possession of the data while we assure that it is compliant with all regulations. Since pricing is flexible and based on your selected needs, this the smart, inexpensive way to go for your financial needs.",
    },
    {
      title: "Data Management",
      image: "assets/img/icon/data-manage.avif",
      description:
        "We provide a complete suite of data asset management services to amplify your team's capabilities in collecting, processing, and effectively utilizing data. From initial collection to ultimate use, each of the stages is guaranteed to move fast, under the tenet of secure approaches, and is fully compliance assured. Our solutions guarantee data accuracy, consistency, and convenient access to the user. Through these services, we facilitate the move from legacy systems, the reconciliation of diverse data sources, and the assurance of regulatory compliances. Services in data management comprise transformation, framework design, archiving, integration, migration, governance, representation, security, meta-data management, and master data management. We seek the proactive path of detecting and solving issues early on, cutting threats and costs, utilizing the latest technology together with established best practices to convert raw data into a key asset for rapid growth and informed decision-making within your company.",
    },
  ];

  const handleToggle = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <section className="expertise-section">
      <div className="container">
        <h2 className="expertise-heading">Our Expertise</h2>
        <p className="expertise-description">
          We provide expert digital solutions for your business needs. Our teams
          are dedicated to delivering quality, efficiency, and growth through
          innovation in technology and smart strategy.
        </p>

        <div className="expertise-grid">
          {services.map((service, idx) => {
            const isExpanded = expandedIndex === idx;
            return (
              <div className="expertise-card" key={idx}>
                <div className="expertise-icon">
                  <img src={service.image} alt={service.title} />
                </div>
                <div className="expertise-content">
                  <h4 className="expertise-title">{service.title}</h4>
                  <p
                    className={`expertise-text ${isExpanded ? "expanded" : ""}`}
                  >
                    {service.description}
                  </p>
                  <button
                    onClick={() => handleToggle(idx)}
                    className="read-more-btn"
                  >
                    {isExpanded ? "Read Less" : "Read More"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        .expertise-section {
          padding: 5rem 1rem;
          background-color: #e8ebed;
          text-align: center;
        }

        .expertise-heading {
          color: #18336c;
          margin-bottom: 1rem;
          opacity: 0;
          transform: translateY(40px);
          transition: all 0.6s ease-out;
        }

        .expertise-description {
          margin-bottom: 4rem;
          opacity: 0;
          transform: translateY(40px);
          transition: all 0.6s ease-out;
        }

        .expertise-heading.show,
        .expertise-description.show {
          opacity: 1;
          transform: translateY(0);
        }

        .expertise-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 2rem;
          max-width: 1200px;
          margin: 0 auto;
           align-items: start;
        }

        .expertise-card {
          background: white;
          border-radius: 1.25rem;
          padding: 2rem;
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.05);
          transition: all 0.4s ease;
          transform: translateY(30px);
          opacity: 0;
           display: flex;          
          flex-direction: column;  
          justify-content: space-between; 
        //  height: 100%;  
        min-height:440px;
        }
        
        .expertise-content {
           display: flex;
           flex-direction: column;
           flex-grow: 1;
         }

        .expertise-card.show {
          transform: translateY(0);
          opacity: 1;
        }

        .expertise-card:hover {
          box-shadow: 0 0px 30px #18336c;
        }

        .expertise-icon {
          width: 100px;
          height: 100px;
          margin: 0 auto 1.5rem;
        }

        .expertise-icon img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .expertise-icon img:hover {
          transform: rotate(360deg);
          transition: transform 0.3s ease;
        }

        .expertise-title {
          color: #18336c;
          margin-bottom: 0.75rem;
          line-height: 1.2;
          // max-height: 3em;
          // overflow: hidden;
        }

        .expertise-text {
          max-height: 4.9em;
          overflow: hidden;
          position: relative;
          transition: max-height 0.4s ease;
        }

        .expertise-text.expanded {
          // max-height: 1000px;
          max-height:none;
        }

        .read-more-btn {
          background: none;
          color: #18336c;
          border: none;
          margin-top: 0.75rem;
          font-weight: 600;
          cursor: pointer;
          border:1px solid #18336c;
          width: fit-content;    
          align-self: center;   
        }
      `}</style>
    </section>
  );
};

export default Expertise;
